<template>
	<Tag :text="companyAssetTag.label" :background="tagBackground" class="company-assets-tag" />
</template>

<script setup lang="ts">
import { CompanyAssetTag } from 'types/company-element';
import { computed } from 'vue';
import Tag from '@components/tags/tag-component.vue';
import { TagBackground } from 'types/layout';
interface Props {
	companyAssetTag: CompanyAssetTag;
}
const props = defineProps<Props>();

const tagBackground = computed((): TagBackground => {
	const type = props.companyAssetTag.assetType;

	switch (type) {
		case 'industry':
			return 'blue';
		case 'assetType':
			return 'green';
		default:
			return 'default';
	}
});
</script>
